<template>
  <v-card class="card" color="primary">
    <v-card-title>
      <div class="text-h5 font-weight-bold">Trayectoria Laboral</div>
    </v-card-title>
    <v-card-text>
      <v-col lg="12" align="right">
        <v-btn color="secondary" class="primary--text px-8" @click="registrarTrayectoriaLaboral">
          Registrar Trayectoria Laboral
        </v-btn>
      </v-col>
      <v-data-table
        :headers="headersTrayectoria"
        :items="trayectoriaItems"
        class="transparent"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:item.empresa="{ item }">
          <div style="white-space: pre-line">{{ item.empresa }}</div>
        </template>
        <template v-slot:item.puesto="{ item }">
          <span>{{ item.puesto }}</span>
        </template>
        <template v-slot:item.periodo="{ item }">
          <span>{{ item.periodo }}</span>
        </template>
        <template v-slot:item.motivoConclusion="{ item }">
          <span>{{ item.motivoConclusion }}</span>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-btn icon color="secondary" small @click="openEditModal(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '../../plugins/dialog-types'

export default {
  props: {
    idPersonal: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      headersTrayectoria: [
        { text: 'Empresa', value: 'empresa' },
        { text: 'Puesto', value: 'puesto' },
        { text: 'Periodo', value: 'periodo' },
        { text: 'Motivo de Conclusión', value: 'motivoConclusion' },
        { text: 'Acciones', value: 'acciones', sortable: false },
      ],
      DIALOG_TYPES,
    }
  },
  watch: {
    idPersonal: {
      handler(newVal) {
        if (newVal) {
          this.fetchByPersonal(newVal)
        }
      },
      immediate: true,
    },
  },

  computed: {
    ...mapGetters({
      trayectoriaItems: 'trayectoriaLaboral/getTrayectorias',
    }),
  },

  methods: {
    ...mapActions('trayectoriaLaboral', ['fetchByPersonal']),
    ...mapMutations('dialog', ['SET_DIALOG']),

    openEditModal(item) {
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.EDITAR_TRAYECTORIA_LABORAL,
        props: { trayectoriaLaboral: item, idPersonal: this.idPersonal },
      })
    },
    registrarTrayectoriaLaboral() {
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.REGISTRAR_TRAYECTORIA_LABORAL,
        props: { idPersonal: this.idPersonal },
      })
    },
  },

  created() {
    this.fetchByPersonal(this.idPersonal)
  },
}
</script>
